const en = {
  // Navbar
  'nav.home': 'Home',
  'nav.services': 'Services',
  'nav.portfolio': 'Portfolio',
  'nav.about': 'About',
  'nav.why': 'Why FMA',
  'nav.faq': 'FAQ',
  'nav.contact': 'Contact',
  'nav.cta': 'Free Estimate',

  // Portfolio Hero
  'portfolio.hero.title': 'Project Portfolio',
  'portfolio.hero.titleEm': '& Case Studies',

  // Hero
  'hero.brand': 'Facility Maintenance of America',
  'hero.servingArea': 'Serving Greater Atlanta & Beyond',
  'hero.panel1.tag': 'Multi-Family & Apartment Excellence',
  'hero.panel1.title': 'Multi-Family &\nApartment Maintenance',
  'hero.panel1.subtitle': 'Your Apartment Community, Maintained Better.',
  'hero.panel1.desc': 'From unit turns and common area upkeep to structural repairs and exterior maintenance — FMA Crew is the trusted maintenance partner for apartment communities and multi-family properties across Greater Atlanta.',
  'hero.panel1.feat1': 'Apartment Unit Turns',
  'hero.panel1.feat2': 'Common Area Upkeep',
  'hero.panel1.feat3': 'Exterior & Facade',
  'hero.panel1.feat4': 'Licensed Professionals',
  'hero.panel1.cta': 'Explore Services',
  'hero.panel2.tag': 'Remodeling & Renovation',
  'hero.panel2.title': 'Residential &\nCommercial Remodeling',
  'hero.panel2.subtitle': 'Crafted to the Highest Standard',
  'hero.panel2.desc': "We don't just remodel — we craft spaces that reflect excellence in every detail, from the first blueprint to the final finish.",
  'hero.panel2.feat1': 'Kitchen & Bath',
  'hero.panel2.feat2': 'Interior Renovation',
  'hero.panel2.feat3': 'Commercial Build-Out',
  'hero.panel2.feat4': 'No Shortcuts. Ever.',
  'hero.panel2.cta': 'Get a Free Estimate',

  // Services
  'svc.label': 'Our Services',
  'svc.heading': 'What We',
  'svc.headingEm': 'Do',
  'svc.desc': 'Specialized apartment and multi-family property maintenance, plus full-scope remodeling services — one trusted team committed to the highest standard on every project.',
  'svc.cat1.name': 'Multi-Family & Apartment Maintenance',
  'svc.cat1.desc': 'Comprehensive maintenance and repair solutions purpose-built for apartment communities and multi-family properties — keeping your asset safe, attractive, and resident-ready year-round.',
  'svc.cat1.svc1': 'Apartment Unit Turns & Make-Readys',
  'svc.cat1.svc2': 'Common Area Maintenance & Upkeep',
  'svc.cat1.svc3': 'Exterior & Facade Repairs',
  'svc.cat1.svc4': 'Waterproofing & Structural Repairs',
  'svc.cat1.svc5': 'Balcony & Stairwell Restoration',
  'svc.cat1.svc6': 'Preventive Maintenance Programs',
  'svc.cat2.name': 'Residential Remodeling',
  'svc.cat2.desc': 'Transform your home with expert craftsmanship — from kitchens and bathrooms to full-home renovations.',
  'svc.cat2.svc1': 'Kitchen & Bath Remodeling',
  'svc.cat2.svc2': 'Interior Renovation',
  'svc.cat2.svc3': 'Flooring & Tile Installation',
  'svc.cat2.svc4': 'Painting & Finishing',
  'svc.cat2.svc5': 'Basement Finishing',
  'svc.cat2.svc6': 'Room Additions',
  'svc.cat3.name': 'Commercial Remodeling',
  'svc.cat3.desc': 'Upgrade your commercial space with professional build-outs, renovations, and tenant improvements.',
  'svc.cat3.svc1': 'Office & Retail Build-Outs',
  'svc.cat3.svc2': 'Tenant Improvements (TI)',
  'svc.cat3.svc3': 'ADA Compliance Upgrades',
  'svc.cat3.svc4': 'Structural Modifications',
  'svc.cat3.svc5': 'Commercial Painting',
  'svc.cat3.svc6': 'Restroom & Break Room Upgrades',
  'svc.cat4.name': 'General Maintenance',
  'svc.cat4.desc': 'Reliable, responsive maintenance services to keep your property in peak condition year-round.',
  'svc.cat4.svc1': 'Plumbing Repairs',
  'svc.cat4.svc2': 'Electrical Services',
  'svc.cat4.svc3': 'HVAC Maintenance',
  'svc.cat4.svc4': 'Carpentry & Drywall',
  'svc.cat4.svc5': 'Pressure Washing',
  'svc.cat4.svc6': 'Landscaping & Grounds',
  'svc.btnEstimate': 'Get a Free Estimate',
  'svc.btnPortfolio': 'View Portfolio',

  // About
  'about.label': 'About FMA Crew',
  'about.heading': 'Your Trusted Partner for',
  'about.headingEm': 'Maintenance & Remodeling',
  'about.p1': 'FMA Crew — <strong>Facility Maintenance of America</strong> — is a full-service building maintenance and construction company serving Greater Atlanta with two core strengths: specialized multi-family and apartment maintenance, and full-scope residential and commercial remodeling.',
  'about.p2': 'From apartment unit turns, make-readys, common area upkeep, and preventive maintenance programs — to kitchen and bath remodels, full interior renovations, basement finishing, room additions, and commercial build-outs — our experienced team delivers consistent, high-quality results that protect your asset, elevate your space, and exceed expectations on every single project.',
  'about.badge.title': 'Excellence First',
  'about.badge.label': 'Our Standard on Every Property',
  'about.stat1.value': 'GA LIC',
  'about.stat1.label': 'Licensed & Insured',
  'about.stat2.value': '10+',
  'about.stat2.label': 'Years Team Experience',
  'about.stat3.value': 'A+',
  'about.stat3.label': 'Workmanship Standard',
  'about.stat4.value': '24/7',
  'about.stat4.label': 'Emergency Response',
  'about.svc1.title': 'Multi-Family & Apartment Maintenance',
  'about.svc1.desc': 'Unit turns, common areas, exterior repairs, waterproofing & preventive programs — keeping apartment communities safe and resident-ready year-round.',
  'about.svc2.title': 'Residential & Commercial Remodeling',
  'about.svc2.desc': 'Kitchen & bath remodels, interior renovations, basement finishing, room additions, and commercial build-outs — crafted from first permit to final finish.',
  'why.label': 'Why Choose Us',
  'why.heading': 'The FMA Crew',
  'why.headingEm': 'Difference',
  'why.desc': 'We combine professional expertise, transparent communication, and genuine care for every apartment community and property we serve.',
  'why.item1.title': 'Licensed & Insured',
  'why.item1.desc': 'Fully licensed contractors and insured for your complete peace of mind on every apartment and multi-family project.',
  'why.item2.title': 'On-Time Delivery',
  'why.item2.desc': 'We respect your lease schedule and resident commitments. Every unit turn and project is delivered on time and within budget.',
  'why.item3.title': 'Dedicated Support',
  'why.item3.desc': '24/7 responsive communication with a dedicated point of contact — so your property manager always has a direct line.',
  'why.item4.title': 'Local Experts',
  'why.item4.desc': 'Deep roots in the Greater Atlanta apartment market with knowledge of local codes, HOA requirements, and vendor networks.',
  'why.item5.title': 'One Company, All Services',
  'why.item5.desc': 'Unit turns, structural repairs, common area upgrades, and full remodels — no need to manage multiple contractors for your community.',
  'why.item6.title': 'Pursuit of Excellence',
  'why.item6.desc': "We don't just aim to finish — we aim to be the best. Every apartment community we serve is held to our highest internal standard, and we keep going until the result reflects that commitment.",

  // Testimonials
  'testi.label': 'Client Reviews',
  'testi.heading': 'What Our Clients Say',
  'testi.desc': 'Real feedback from homeowners, apartment managers, and property owners across Greater Atlanta who trust FMA Crew for interior painting, home renovation, and everyday repairs.',
  'testi.item1.name': 'Marcus D.',
  'testi.item1.role': 'Homeowner · Smyrna, GA',
  'testi.item1.text': "FMA Crew painted the entire interior of our home — ceilings, walls, trim, and doors across 12 rooms. The prep work was impeccable: every surface was patched, sanded, and primed before a single drop of paint went on. The finish is smooth, clean, and exactly the color palette we chose. Hands-down the best interior paint job we have ever had.",
  'testi.item1.service': 'Interior Painting & Finishing',
  'testi.item2.name': 'Sandra R.',
  'testi.item2.role': 'Property Manager · Alpharetta, GA',
  'testi.item2.text': "We rely on FMA Crew for unit turns across our entire apartment community. They handle interior painting, drywall repair, fixture replacements, and make-ready punch lists in every unit — consistently, on schedule, and to a high standard every single time. Our vacancy turnaround time has dropped significantly since partnering with them.",
  'testi.item2.service': 'Unit Turns & Interior Repairs',
  'testi.item3.name': 'Tony W.',
  'testi.item3.role': 'Homeowner · Kennesaw, GA',
  'testi.item3.text': "We hired FMA Crew for a full home-base renovation — new kitchen layout, bathroom remodel, fresh interior paint throughout, and hardwood floor refinishing. They managed every trade, kept us informed daily, and delivered a completely transformed home. The quality of the renovation exceeded every expectation. We will absolutely hire them again.",
  'testi.item3.service': 'Home Renovation & Remodeling',
  'testi.badge1.label': 'Licensed & Insured',
  'testi.badge1.sub': 'Georgia State Licensed',
  'testi.badge2.label': 'Greater Atlanta',
  'testi.badge2.sub': 'Apartment Communities We Serve',
  'testi.badge3.label': '5-Star Rated',
  'testi.badge3.sub': 'Pursuit of Excellence',

  // Contact
  'contact.label': 'Contact Us',
  'contact.hero.badge': '',
  'contact.hero.title': 'Get a Free',
  'contact.hero.titleEm': 'Estimate',
  'contact.hero.subtitle': '',
  'contact.heading': 'Get Your Free Estimate',
  'contact.desc': "Tell us about your apartment community or property and we'll get back to you within 24 hours with a no-obligation estimate.",
  'contact.g1.title': '24-Hour Response',
  'contact.g1.desc': 'Every estimate request answered within one business day — guaranteed.',
  'contact.g1.badge': 'Guaranteed',
  'contact.g2.title': 'Free Estimates',
  'contact.g2.desc': 'Detailed project quotes at absolutely zero cost or obligation.',
  'contact.g2.badge': 'No Cost',
  'contact.g3.title': 'Licensed & Insured',
  'contact.g3.desc': 'All work by fully licensed, bonded, and insured GA professionals.',
  'contact.g3.badge': 'GA Licensed',
  'contact.g4.title': 'Excellence Driven',
  'contact.g4.desc': 'We hold ourselves to the highest standard — every estimate, every unit turn, every apartment community project.',
  'contact.g4.badge': 'Our Promise',
  'contact.info1.label': 'Phone',
  'contact.info2.label': 'Email',
  'contact.info3.label': 'Office Address',
  'contact.info4.label': 'Business Hours',
  'contact.info4.value': 'Mon – Fri: 09:00 am – 05:00 pm\nSat: Closed\nSun: Closed',
  'contact.map.title': 'Service Area Coverage',
  'contact.map.sub': 'Greater Atlanta Apartment Communities & Beyond',
  'contact.map.active': 'Active',
  'contact.map.areasLabel': 'Areas We Serve',
  'contact.form.title': 'Project Inquiry Form',
  'contact.form.sub': 'Fill in the details below for your free estimate',
  'contact.form.badge': '24-Hr Response',
  'contact.form.badgeSub': 'Guaranteed',
  'contact.form.firstName': 'First Name *',
  'contact.form.firstPlaceholder': 'John',
  'contact.form.lastName': 'Last Name *',
  'contact.form.lastPlaceholder': 'Smith',
  'contact.form.email': 'Email Address *',
  'contact.form.phone': 'Phone Number',
  'contact.form.service': 'Service Needed *',
  'contact.form.serviceDefault': 'Select a service...',
  'contact.form.svc1': 'Multi-Family & Apartment Maintenance',
  'contact.form.svc2': 'Apartment Unit Turns & Make-Readys',
  'contact.form.svc3': 'Residential Remodeling',
  'contact.form.svc4': 'Commercial Remodeling',
  'contact.form.svc5': 'General Maintenance',
  'contact.form.svc6': 'Other / General Inquiry',
  'contact.form.property': 'Property / Community Name & Address',
  'contact.form.propertyPlaceholder': 'Sunset Apartments, 123 Main St, Atlanta, GA',
  'contact.form.message': 'Project Details *',
  'contact.form.messagePlaceholder': 'Describe your apartment community, number of units, maintenance needs, timeline, or any specific requirements...',
  'contact.form.submit': 'Request Free Estimate',
  'contact.form.submitting': 'Sending...',
  'contact.form.privacy': 'Your information is secure and never shared. We respond within 24 hours.',
  'contact.form.success': "Your request has been sent! We'll be in touch within 24 hours.",
  'contact.form.error': 'Something went wrong. Please call us at 470-222-5777.',

  // FAQ
  'faq.label': 'FAQ',
  'faq.hero.badge': '',
  'faq.hero.title': 'Frequently Asked',
  'faq.hero.titleEm': 'Questions',
  'faq.hero.subtitle': '',
  'faq.heading': 'Frequently Asked',
  'faq.headingEm': 'Questions',
  'faq.desc': 'Find answers to common questions about our apartment maintenance services, process, and what to expect when partnering with FMA Crew.',
  'faq.sidebar.questions': 'Questions Answered',
  'faq.sidebar.stillHave': 'Still have questions?',
  'faq.sidebar.stillHaveDesc': 'Our team is happy to answer anything not covered here. Reach out directly.',
  'faq.sidebar.call': 'Call Us',
  'faq.sidebar.email': 'Email Us',
  'faq.sidebar.ready': 'Ready to get started?',
  'faq.sidebar.readyDesc': 'Get a detailed, no-obligation estimate for your apartment community within 24 hours.',
  'faq.sidebar.btn': 'Request Free Estimate',
  'faq.sidebar.otherTopics': 'Other Topics',
  'faq.sidebar.browse': 'Browse',
  'faq.sidebar.commonQ': 'common questions about our',
  'faq.sidebar.services': 'services.',
  'faq.cat1.label': 'Multi-Family & Apartment Maintenance',
  'faq.cat1.q1': 'What does multi-family and apartment maintenance include?',
  'faq.cat1.a1': 'Our multi-family and apartment maintenance covers the full range of services an apartment community needs — unit turns and make-readys, common area maintenance (lobbies, hallways, amenity areas), exterior and facade repairs, balcony and stairwell restoration, waterproofing, structural repairs, building systems inspection, and customized preventive maintenance programs. We handle both reactive repairs and scheduled upkeep to keep your property safe, attractive, and resident-ready.',
  'faq.cat1.q2': 'Can you handle unit turns and make-readys at scale?',
  'faq.cat1.a2': 'Yes — unit turn management is one of our core strengths. We coordinate multi-unit make-ready schedules to minimize vacancy time and maximize NOI for property managers. Our crews handle painting, cleaning prep, flooring repairs, fixture replacements, drywall patching, and full make-ready checklists efficiently and to a consistent standard across all units.',
  'faq.cat1.q3': 'How quickly can you respond to urgent apartment repairs?',
  'faq.cat1.a3': 'We prioritize urgent structural and safety issues with fast dispatch — typically within 2–4 hours for emergencies such as water intrusion, structural damage, or exterior hazards. Our team is equipped to assess and stabilize the situation immediately, then develop a full repair plan. We understand that resident safety and satisfaction are your top priorities, and we treat them as ours.',
  'faq.cat1.q4': 'Can you set up a preventive maintenance program for our apartment community?',
  'faq.cat1.a4': 'Absolutely. We design customized preventive maintenance schedules — monthly, quarterly, or semi-annual — specifically for apartment communities. Programs include structural inspections, exterior and facade checks, waterproofing assessments, balcony and stairwell evaluations, common area reviews, and building systems inspections. Preventive programs significantly reduce emergency repair costs, protect your asset value, and improve resident satisfaction.',
  'faq.cat1.q5': 'Do you work with property management companies and HOAs?',
  'faq.cat1.a5': 'Yes — we regularly partner with property management companies, HOAs, and apartment ownership groups. We understand the unique communication and reporting requirements of managed communities and provide regular project updates, photo documentation, and completion reports. We also coordinate directly with residents when needed to minimize disruption during maintenance and repair work.',
  'faq.cat2.label': 'Residential Remodeling',
  'faq.cat2.q1': 'How long does a typical kitchen or bathroom remodel take?',
  'faq.cat2.a1': 'A standard kitchen remodel typically takes 6–12 weeks depending on scope, custom cabinetry lead times, and permit approvals. Bathroom remodels generally run 3–6 weeks. We provide a detailed project schedule at the start so you know exactly what to expect at each phase.',
  'faq.cat2.q2': 'Do you handle permits and inspections?',
  'faq.cat2.a2': 'Yes — we pull all required permits, schedule inspections, and manage the process from start to finish. You never need to deal with the city or county yourself. All our work is code-compliant and fully inspected before we consider a project complete.',
  'faq.cat2.q3': 'Can you work with my designer or architect?',
  'faq.cat2.a3': 'Absolutely. We regularly collaborate with interior designers, architects, and decorators. If you already have design plans or a preferred designer, we integrate seamlessly. We can also connect you with trusted local designers if you need recommendations.',
  'faq.cat2.q4': 'What is your payment schedule for remodeling projects?',
  'faq.cat2.a4': 'Typically we structure payments in three milestones: a deposit upon contract signing, a mid-project payment at framing/rough-in completion, and the final balance upon project completion and your satisfaction. We never ask for the majority of funds upfront.',
  'faq.cat2.q5': 'Do you offer a warranty on remodeling work?',
  'faq.cat2.a5': 'Yes — all our workmanship is backed by a 1-year warranty on labor. Additionally, materials carry manufacturer warranties which we transfer to you at project completion. If any issue arises within the warranty period, we return and fix it at no charge.',
  'faq.cat3.label': 'Commercial Remodeling',
  'faq.cat3.q1': 'Can you work around our business hours to minimize downtime?',
  'faq.cat3.a1': 'Yes — we regularly schedule commercial work during evenings, weekends, and phased hours to keep your business operational. For tenant improvements in occupied buildings, we coordinate directly with property management and neighboring tenants to minimize disruption.',
  'faq.cat3.q2': 'Do you handle Tenant Improvement (TI) allowance projects?',
  'faq.cat3.a2': "Yes, we have extensive experience with TI projects. We work directly with landlords and tenants to manage allowance budgets, coordinate landlord approval requirements, and deliver build-outs that meet both lease specifications and the tenant's operational needs.",
  'faq.cat3.q3': 'What types of commercial spaces do you remodel?',
  'faq.cat3.a3': "We work across a wide range of commercial spaces: office suites and full floor build-outs, retail stores and boutiques, restaurants and cafes, medical and dental offices, fitness studios, salons, and light industrial spaces. If you're unsure whether we cover your space type, just reach out.",
  'faq.cat3.q4': 'How do you ensure compliance with building codes and ADA requirements?',
  'faq.cat3.a4': 'Every project is reviewed for local building code compliance before work begins. We are fully up to date with ADA requirements and proactively flag any compliance upgrades needed. All projects are permitted and inspected by the appropriate municipal authority.',
  'faq.cat3.q5': 'How soon can you start a commercial project?',
  'faq.cat3.a5': 'For most commercial projects, we can begin the design/planning phase immediately and break ground within 2–4 weeks depending on permit timelines and material procurement. We prioritize scheduling to match your lease commencement date or business opening target.',
  'faq.cat4.label': 'General Maintenance',
  'faq.cat4.q1': 'Do you offer emergency maintenance services?',
  'faq.cat4.a1': 'Yes — we provide emergency response for urgent issues like burst pipes, electrical hazards, HVAC failures, and roof leaks. Our emergency line is available around the clock. Response time for true emergencies is typically within 2–4 hours depending on location.',
  'faq.cat4.q2': 'Can you set up a recurring preventive maintenance schedule?',
  'faq.cat4.a2': 'Absolutely. We offer customized preventive maintenance contracts — monthly, quarterly, or semi-annual visits — covering HVAC filter changes, plumbing checks, exterior inspections, lighting, and more. Preventive programs significantly reduce emergency repair costs over time.',
  'faq.cat4.q3': 'What trades does your maintenance team cover?',
  'faq.cat4.a3': 'Our in-house team handles general carpentry, drywall, painting, and basic plumbing and electrical. For specialized trades (licensed plumbing, electrical, HVAC, roofing), we deploy vetted and licensed subcontractors from our established vendor network — all coordinated by us.',
  'faq.cat4.q4': 'Do you service both residential and commercial properties?',
  'faq.cat4.a4': 'Yes — we maintain both residential properties (single-family homes, townhomes, condos, apartment communities) and commercial properties (office parks, retail centers, restaurants, light industrial). Our teams are experienced with the unique demands of each property type.',
  'faq.cat4.q5': 'How do I get started with a maintenance contract?',
  'faq.cat4.a5': 'The process is simple: contact us for a free property assessment, where we walk through the property and identify your needs. We then provide a customized maintenance proposal. Once approved, we get started typically within 1 week. No long-term lock-in contracts — we earn your continued business through results.',

  // Footer
  'footer.tagline': 'Specialized multi-family and apartment maintenance, plus full-service building construction and remodeling — serving Greater Atlanta and beyond.',
  'footer.svcHeading': 'Services',
  'footer.compHeading': 'Company',
  'footer.svc1': 'Multi-Family & Apartment Maintenance',
  'footer.svc2': 'Residential Remodeling',
  'footer.svc3': 'Commercial Remodeling',
  'footer.svc4': 'General Maintenance',
  'footer.link1': 'About FMA Crew',
  'footer.link2': 'Why Choose Us',
  'footer.link3': 'Contact Us',
  'footer.link4': 'Free Estimate',
  'footer.newsletter.title': 'Stay Updated',
  'footer.newsletter.desc': 'Get tips on apartment maintenance, multi-family property management, and service updates.',
  'footer.newsletter.placeholder': 'your@email.com',
  'footer.newsletter.btn': 'Subscribe',
  'footer.newsletter.success': 'Subscribed! Thank you.',
  'footer.copy': '© 2026 FMA Crew — Facility Maintenance of America. All rights reserved.',
};

export default en;
